export default "__VITE_ASSET__C88kplsw__"